export default "__VITE_ASSET__Dy9evBLK__"